export function toDOMPointInit(value, defaultW = 1) {
    if (value == null) {
        return undefined;
    }
    return { x: value.x, y: value.y, z: value.z, w: 'w' in value ? value.w : defaultW };
}
